import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { formatToCNPJ } from 'brazilian-values';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel } from '@woovi/ui';
import { obscureCNPJ } from '@woovi/utils';

import type { PaymentCheckoutCompanyData_company$key } from './__generated__/PaymentCheckoutCompanyData_company.graphql.ts';

import type { ReactNode } from 'react';

type PaymentCheckoutCompanyDataProps = {
  company: PaymentCheckoutCompanyData_company$key;
};

const PaymentCheckoutCompanyData = (
  props: PaymentCheckoutCompanyDataProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const company = useFragment<PaymentCheckoutCompanyData_company$key>(
    graphql`
      fragment PaymentCheckoutCompanyData_company on Company {
        nameFriendly
        taxID {
          taxID
        }
      }
    `,
    props.company,
  );

  return (
    <Stack>
      <AccountInfoLabel
        label={t('Addressee')}
        text={
          <>
            <Typography
              sx={{
                fontSize: theme.typography.pxToRem(16),
                overflowWrap: 'anywhere',
              }}
            >
              {company.nameFriendly}
            </Typography>
            <Typography
              sx={{
                fontSize: theme.typography.pxToRem(16),
                overflowWrap: 'anywhere',
              }}
            >
              CNPJ: {obscureCNPJ(formatToCNPJ(company.taxID.taxID))}
            </Typography>
          </>
        }
      />
    </Stack>
  );
};

export default PaymentCheckoutCompanyData;
